const getters = {
  customerId: state => state.customer.customerId,
  customerName: state => state.customer.customerName,
  mobile: state => state.customer.mobile,
  gender: state => state.customer.gender,
  birthday: state => state.customer.birthday,
  age: state => state.customer.age,
  mzCode: state => state.customer.mzCode,
  employeeName: state => state.customer.employeeName,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js